<ion-content class="ion-no-padding preview-content" [fullscreen]="true">
  <button class="img-preview-close" (click)="dismiss()">
    <ion-icon name="close"></ion-icon>
  </button>
  <div class="preview-wrap">
    <img [src]="imageUrl" [alt]="altText || 'Preview'" (click)="$event.stopPropagation()" class="img-preview-img" />
  </div>
</ion-content>